import React from "react";
import { FilterStore } from "stores";

import Box from "@mui/material/Box";

const Indicator: React.FC = (): JSX.Element | null => {
  const {
    state: { filter, indicator },
    dispatch,
  } = React.useContext(FilterStore);

  if (indicator.size === 0) return null;
  return (
    <Box
      sx={{
        position: "sticky",
        mb: 2,
        top: -1,
        backgroundColor: "#FFFFFFEE",
      }}
    >
      <Box>
        {Array.from(indicator, ([key, f]: [string | number, any]) => (
          <span key={key}>{f({ filter: filter[key], dispatch })}</span>
        ))}
      </Box>
    </Box>
  );
};

export default Indicator;
